import {fabric} from 'fabric';

fabric.Object.prototype.set({
    transparentCorners: false,
    cornerColor: '#ffffff',
    cornerSize: 12,
    cornerStrokeColor: '#4cc0e7'
})

fabric.Object.NUM_FRACTION_DIGITS = 17;

fabric.util.object.extend(fabric.Object.prototype, {
    setBoundingBox(prop, val) {
        const bbox = this.getBoundingRect(1, 1);
        this.set(prop, (this[prop] - bbox[prop]) + val);
        this.setCoords();
    },
    getObjectArea() {
        return (this.getBoundingRect(true, true).width * this.getBoundingRect(true, true).height);
    },
});

fabric.WebglFilterBackend.prototype.chooseFastestCopyGLTo2DMethod = function() {
    this.copyGLTo2D = copyGLTo2DDrawImage;
};
function copyGLTo2DDrawImage(gl, pipelineState) {
    const glCanvas = gl.canvas;
    const targetCanvas = pipelineState.targetCanvas;
    const ctx = targetCanvas.getContext('2d');

    ctx.translate(0, targetCanvas.height); // move it down again
    ctx.scale(1, -1); // vertical flip

    // where is my image on the big glCanvas?
    var sourceY = glCanvas.height - targetCanvas.height;

    ctx.drawImage(
        glCanvas,
        0,
        sourceY,
        targetCanvas.width,
        targetCanvas.height,
        0,
        0,
        targetCanvas.width,
        targetCanvas.height
    );
}

fabric.textureSize = 8192;
fabric.filterBackend = new fabric.Canvas2dFilterBackend();

fabric.isWebglSupported(fabric.textureSize);


fabric.Image.filters.Feathering4 = fabric.util.createClass(
    fabric.Image.filters.BaseFilter, {
        type: 'feathering4',

        edgeTransparentPixels : [],

        applyTo: function (canvasEl) {
            if (canvasEl.context instanceof WebGLRenderingContext) {
                // Handle WebGL rendering using applyToWebGL
                this.applyToWebGL(canvasEl.context);
                return;
            }

            var imageData = canvasEl.imageData;

            var imageWidth = canvasEl.sourceWidth;
            this.edgeTransparentPixels.forEach(function(pixel) {
                var index = (pixel.y * imageWidth + pixel.x) * 4;
                var alphaIndex = index + 3;
                if(imageData.data[alphaIndex] > pixel.alpha)
                {
                imageData.data[alphaIndex] = pixel.alpha;
                }
            });
            return imageData;
        },

        applyToWebGL: function (webglContext) {
            // Handle WebGL rendering here
            // You can implement your WebGL filter logic with the same feathering effect

            // For simplicity, let's set the fragment shader for the feathering effect
            webglContext.addColorStop(0.05, [0, 0, 0, 0]); // Fully transparent for outer 5%
            webglContext.addColorStop(0.95, [0, 0, 0, 255]); // Fully opaque for the inner area
        },
        isNeutralState: function() {
            // Always return false, so the filter is always applied
            return false;
        },
        toObject: function() {
            return {
                type: this.type,
            };
        },
    }
);

fabric.Image.filters.Feathering4.fromObject = function(object, callback) {
    callback && callback(new fabric.Image.filters.Feathering4(object));
};

export const setCanvasCursor = (canvas, cursor) => {
    canvas.defaultCursor = cursor;
    canvas.hoverCursor = cursor;
    canvas.moveCursor = cursor;
};


